import PropTypes from "prop-types";
import React, { useEffect, useState, useContext } from "react";
import Swiper from "react-id-swiper";
import SectionTitle from "../../components/section-title/SectionTitle";
import ProductGridTwo from "./ProductGridTwo";
import { AuthContext } from "../../common/Auth"
import { USERTYPES } from "../../constant/userType"
import EditProductSliderIcon from "./editProductSlidersettings/EditProductSliderIcon"

const ProductSlider = ({ spaceBottomClass, category }) => {
  const [productSliderSettings, setProductSliderSettings] = useState(null)
  const { themeSettingsData, userType } = useContext(AuthContext)
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
  useEffect(() => {
    if (themeSettingsData && themeSettingsData.length > 0) {
      themeSettingsData.map((i) => {
        if (i.settingsName === "productSlider") {
          setProductSliderSettings(i.values[0]);
        }
      })
    }
  }, [themeSettingsData])
  let pt = "";
  let pb = "";
  let mb = "";
  let mt = "";
  let mr = "";
  let ml = "";
  let pl = "";
  let pr = "";
  let fullSection = "";
  let bgImage = "";
  let bgColor = "";
  let titleData = "";
  if (productSliderSettings) {

    pt = productSliderSettings.paddingTop ? productSliderSettings.paddingTop : "pt-0";
    pb = productSliderSettings.paddingBottom ? productSliderSettings.paddingBottom : "pb-0";
    mb = productSliderSettings.marginBottom ? productSliderSettings.marginBottom : "mt-50";
    mt = productSliderSettings.marginTop ? productSliderSettings.marginTop : "mb-50";
    mr = productSliderSettings.marginRight ? productSliderSettings.marginRight : "mr-0";
    ml = productSliderSettings.marginLeft ? productSliderSettings.marginLeft : "ml-0";
    pl = isMobile ? "pl-2" : ( productSliderSettings.paddingLeft ? productSliderSettings.paddingLeft : "pl-0" );
    pr = isMobile ? "pl-2" : ( productSliderSettings.paddingRight ? productSliderSettings.paddingRight : "pr-0" );
    fullSection = productSliderSettings.fullSection ? "container-fluid" : "container";
    bgImage = productSliderSettings?.bgImage ? productSliderSettings?.bgImage : "";
    bgColor = productSliderSettings?.bgColor ? productSliderSettings?.bgColor : "";
    titleData = productSliderSettings?.sectionTitle ? productSliderSettings?.sectionTitle : "";
  }

  const settings = {
    loop: true,
    slidesPerView: 4,
    // grabCursor: true,
    autoplay: {
      delay: 7000,
      disableOnInteraction: false
    },
    breakpoints: {
      1024: {
        slidesPerView: 4
      },
      768: {
        slidesPerView: 3
      },
      640: {
        slidesPerView: 2
      },
      320: {
        slidesPerView: 1
      }
    },
    observer: true,
    observeParents: true,
    initialSlide: 0,
    speed: 500,
  }



  return (
    <div
      className={`antera-product-slider-section-container related-product-area product-slider-area section-bgImage ${pt} ${pb} ${pl} ${pr} ${mb} ${mt} ${mr} ${ml}`}
      style={(bgImage.length > 0) ? { backgroundImage: `url(${bgImage})` } : { background: bgColor }}
    >
      <div className="edit-inline">
        <EditProductSliderIcon />
      </div>
      <div className={`antera-product-content-container ${fullSection}`}>
        {(productSliderSettings && productSliderSettings?.sectionTitleEnabled) &&
          <SectionTitle
            titleText={productSliderSettings?.sectionTitleEnabled ? (productSliderSettings && productSliderSettings?.sectionTitle != "") ? productSliderSettings?.sectionTitle : "" : null}
            spaceClass="mb-55"
            borderClass="no-border"
          />}
        {(productSliderSettings && (productSliderSettings?.sectionTitleEnabled || productSliderSettings?.sectionSubTitleEnabled)) &&
          <SectionTitle
            // titleText={productSliderSettings.sectionTitleEnabled ? (productSliderSettings && productSliderSettings.sectionTitle != "") ? productSliderSettings.sectionTitle : "New Products" : null}
            subTitleText={productSliderSettings?.sectionSubTitleEnabled ? (productSliderSettings && productSliderSettings?.sectionSubTitle != "") ? productSliderSettings?.sectionSubTitle : "" : null}
            spaceClass="mb-55"
          />}
        <div className="w-100" style={{ overflow: "hidden" }}>
          <Swiper {...settings}>
            <ProductGridTwo
              category={category}
              limit={30}
              sliderClassName="swiper-slide"
              centeredSlides={true}
              colorClass="pro-puce-color"
              productSliderSettings={productSliderSettings}
              isProductSlider={true}
            />
          </Swiper>
        </div>
      </div>
    </div>
  );
};

ProductSlider.propTypes = {
  category: PropTypes.string,
  spaceBottomClass: PropTypes.string
};

export default ProductSlider;
